import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from 'components/loader/loader'
import ProfilePicture from 'components/profile/profile-picture'

import {
	loginUser,
	logoutUser,
	saveUser,
	changeTitle,
	clearPending,
	clearReferrer,
	setTempUiColour
} from 'state/actions'

import { withRouter } from 'react-router'
import Button from 'components/button/button'
import copy from 'fast-copy'
import Icon from 'components/icon/icon'
import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'
import { Link } from 'react-router-dom'
import SmoothCollapse from 'react-smooth-collapse'
import Toggle from 'components/controls/toggle'
import Checkbox from 'components/input/checkbox'

import { getUrlParams } from 'utils/text'
import { isValidFile } from 'utils/file'

import yup from 'yup'

class RegisterUser extends Component {
	get toggleOptions() {
		return [
			{
				name: 'Light UI'
			},
			{
				name: this.state.show_super_dark_ui ? 'Super Dark UI' : 'Dark UI'
			}
		]
	}

	state = {
		isLoading: false,
		first_name: '',
		last_name: '',
		role: '',
		email: '',
		password: '',
		saveSuccess: false,
		error: null,
		imageFile: '',
		imagePreviewUrl: '',
		show_dark_ui: null,
		show_super_dark_ui: false,
		darkToggleClicks: 0,
		hasAcceptedTerms: false,
		validateResponsePinned: false
	}

	UNSAFE_componentWillMount() {
		let tempState = {
			...this.state,
			isGuest: false
		}

		const {
			invitationError,
			invitation,
			userData,
			isNew,
			changeTitle,
			referrer,
			handleError,
			clearReferrer,
		} = this.props

		let shouldPinError = false

		if (invitationError) {
			let error = 'Yikes! Seems like something has broken.'

			switch(invitationError){
				case 'TAKEN':
					error = 'Yikes! This invitation has been accepted already.'
					break
				case 'NONE':
					error = `This invitation couldn't be found. Perhaps it's been deleted?`
					break
			}
			
			handleError(error)

			shouldPinError = true
		}
		
		if (referrer) {
			tempState.referrer = referrer
			handleError(`You've been referred by ${referrer.first_name}! Enjoy unlimited projects forever.`)

			shouldPinError = true

			clearReferrer()
		}

		if (invitation) {
			if (invitation.is_guest) {
				tempState.isGuest = true
			}

			tempState.email = invitation.recipient_email
		}

		if (userData) {
			if (userData.guest_accounts && userData.guest_accounts.length && userData.guest_accounts.includes(userData.last_open_account_id)) {
				tempState.isGuest = true
			}
		}

		if (!isNew) {
			tempState = {
				...tempState,
				...userData
			}
		} else {
			changeTitle(`Let's get going`)
		}

		const email = getUrlParams('email')

		if (email) {
			tempState.email = email
		}

		if(shouldPinError){
			tempState.validateResponsePinned = true
		}

		this.setState(tempState)
	}

	componentWillUnmount() {
		const {
			isOtherUser,
			setTempUiColour
		} = this.props

		if (!isOtherUser) {
			setTempUiColour(-1)
		}
	}

	UNSAFE_componentWillUpdate = nextProps => {
		const {
			handleError,
			affiliate
		} = this.props

		if(!affiliate && nextProps.affiliate){
			this.setState({
				validateResponsePinned: true
			})

			handleError(`You've been referred by ${nextProps.affiliate.name}! Enjoy 10% off Hassl Business for a year.`)
		}
	}

	toggleState = _ => {
		const {
			show_dark_ui,
			darkToggleClicks
		} = this.state

		const turningDark = !show_dark_ui
		const nextDarkToggleClicks = turningDark ? darkToggleClicks + 1 : darkToggleClicks
		const isSuperDark = turningDark && nextDarkToggleClicks % 5 === 0

		this.setState({
			show_dark_ui: turningDark,
			show_super_dark_ui: isSuperDark,
			darkToggleClicks: nextDarkToggleClicks
		})

		this.props.setTempUiColour(isSuperDark ? 2 : turningDark)
	}

	handleChange = (event, input) => {
		let value

		if (input == 'hasAcceptedTerms') {
			value = event
		} else {
			value = event.target.value
		}

		let currentState = copy(this.state)
		currentState[input] = value

		this.setState(currentState)
	}

	handleImageChange = e => {
		let reader = new FileReader()
		let file = e.target.files[0]

		if (!file) {
			return
		}

		const validityCheck = isValidFile(file, 'image', 1)

		if (file && validityCheck.isValid) {
			reader.onloadend = _ => {
				this.setState({
					imageFile: file,
					imagePreviewUrl: reader.result,
				})
			}

			reader.readAsDataURL(file)
		} else if (!validityCheck.isValid) {
			return this.props.handleError(validityCheck.response)
		}
	}

	handleSubmit = async e => {
		if(e){
			e.preventDefault()
			e.stopPropagation()
		}

		const {
			isNew,
			handleError,
			invitation,
			saveUser,
			handleDismiss,
			setLoginCredentials,
			clearPending,
			loginUser,
			goToDashboard,
			isOtherUser
		} = this.props

		const {
			isGuest,
			hasAcceptedTerms,
			referrer
		} = this.state

		// New users schema
		let validateParams = {
			email: yup
				.string()
				.email(`That email doesn't seem to be quite right.`)
				.required(`What's your email?`),
			last_name: yup.string().required(`What's your last name?`),
			first_name: yup.string().required(`So, what's your name?`),
		}

		// Only set password here if you're new
		if (isNew) {
			validateParams.password = yup.string().min(6, 'Your password needs to be at least 6 characters.').required()
		}

		// guest invites don't need a role
		if (!isGuest) {
			validateParams.role = yup.string().required('Please enter your role.')
		}

		const userSchema = yup.object().shape(validateParams)

		// Validate input fields against schema
		try {
			await userSchema.validate({ ...this.state })
		} catch (err) {
			return handleError(err.message)
		}

		if (!hasAcceptedTerms && isNew) {
			return handleError(`Please accept the Terms of Use and Privacy policy.`)
		}

		let requestData = {
			...this.state,
			referrer_id: referrer ? referrer.id : null
		}

		if (invitation) {
			requestData.invitation_id = invitation.id
			requestData.account_id = invitation.account_id
		}

		this.setState({
			isLoading: true,
		})

		saveUser(requestData, response => {
			if (!response) {
				return this.logOut()
			}

			handleDismiss()

			if (response.data === 'TAKEN') {
				//alert('keep this check for pre-accepted invitations');
				this.setState({
					showResponse: true,
					responseMessage: 'This invitation has been accepted already.',
					responseIcon: 'times',
				});
			} else if (response.status && response.status == 422) {
				// local and prod seem to do this differently...?!
				let firstKey
				let errorsObject = null

				if (response.data.errors) {
					errorsObject = response.data.errors
				} else {
					errorsObject = response.data
				}

				firstKey = Object.keys(errorsObject)[0]

				handleError(errorsObject[firstKey][0])

				this.setState({
					isLoading: false,
				})
			} else {
				this.setState({
					showResponse: true,
					responseMessage: 'Success!',
					responseIcon: 'check',
				})

				if (setLoginCredentials) {
					setLoginCredentials(this.state.email, this.state.password)
				}

				setTimeout(_ => {
					if (invitation) {
						clearPending()

						loginUser(this.state, _ => {
							if (this.props.userData) {
								goToDashboard()
							} else {
								this.setState({
									isLoading: false,
								})
							}
						})
					} else {
						// also set validation message here.
						let tempState = {
							showResponse: false,
							isLoading: false,
						}

						if (isNew) {
							tempState.id = this.props.userId

							this.props.successCallback()
						}

						this.setState({
							...tempState
						})
					}
				}, 1000)
			}
		}, isOtherUser)
	}

	logOut = _ => {
		this.props.logoutUser()
	}

	render() {
		const {
			userData,
			handleDismiss,
			validateResponse,
			invitation,
			isNew,
			isOtherUser,
			closeCallback,
		} = this.props

		const {
			isLoading,
			responseMessage,
			responseIcon,
			imagePreviewUrl,
			first_name,
			last_name,
			email,
			role,
			password,
			isGuest,
			showResponse,
			validateResponsePinned
		} = this.state

		let formClass = 'register-container auth-fields'

		if (isLoading) {
			formClass += ' loading'
		}

		let responseExpanded = false

		if (this.props.validateResponse) {
			responseExpanded = true
		}

		const inputs = [
			[
				{
					value: first_name,
					key: 'first_name',
					placeholder: "First name",
					type: 'text'
				},
				{
					value: last_name,
					key: 'last_name',
					placeholder: "Last name",
					type: 'text'
				},
			], [{
				value: email,
				key: 'email',
				placeholder: 'Email address',
				disabled: !!invitation,
				type: 'email'
			}], [{
				value: role ? role : '',
				key: 'role',
				placeholder: "What's your role?",
				hidden: isGuest,
				type: 'text'
			}], [{
				value: password,
				key: 'password',
				placeholder: 'Enter a password',
				hidden: !isNew,
				type: 'password'
			}]
		]

		return (
			<form className={formClass} noValidate onSubmit={this.handleSubmit} onClick={_ => {
				if (window.Keyboard && window.Keyboard.hide) {
					window.Keyboard.hide()
				}
			}} >
				{showResponse ? (
					<div className="response-container">
						<Icon name={responseIcon} />
						<span>
							{responseMessage}
						</span>
					</div>
				) : (
						<Loader visible={isLoading} />
					)}
				<div className="form-fields">
					<div className="left">
						<ProfilePicture
							user={userData}
							handleImageChange={this.handleImageChange}
							editable={true}
							url={imagePreviewUrl}
							size='original'
						/>
					</div>
					<div className="right">
						<SmoothCollapse expanded={responseExpanded}>
							<ValidateResponse
								dismissCallback={handleDismiss}
								response={validateResponse}
								pinned={validateResponsePinned}
								timeout={5000}
							/>
						</SmoothCollapse>
						{inputs.map((inputGroup, index) => {
							let className = 'form-row'

							if (inputGroup.length > 1) {
								className += ' halves'
							}

							return (
								<div className={className} key={index}>
									{inputGroup.map((input, inputIndex) => {
										if (input.hidden) {
											return null
										}

										return (
											<input
												key={inputIndex}
												onClick={e => { e.stopPropagation() }}
												onChange={e => { this.handleChange(e, input.key) }}
												value={input.value} type={input.type}
												placeholder={input.placeholder}
												disabled={!!input.disabled}
											/>
										)
									})}
								</div>
							)
						})}
						{!isOtherUser &&
							<div className="form-row">
								{!isNew ?
									<Toggle
										toggleState={this.state.show_dark_ui}
										toggleChangeCallback={this.toggleState}
										toggleOptions={this.toggleOptions}
									/>
									:
									<label className="domain-toggle" onClick={e => e.stopPropagation()}>
										<Checkbox
											isChecked={this.state.hasAcceptedTerms}
											onChange={isChecked => { this.handleChange(isChecked, 'hasAcceptedTerms') }}
										/>
										<span>
											I have read and agree to the <a href="https://hassl.co/terms-of-use" target="_blank">terms of use</a> and <a href="https://hassl.co/privacy-policy">privacy policy</a>.
										</span>
									</label>
								}
							</div>
						}
						<Button
							size={'big'}
							level={'high'}
							callback={this.handleSubmit}
							label={isNew ? 'Save details' : 'Update profile'}
							icon={'check'}
						/>
						{!isNew && <Button size={'big'} level={'low'} callback={closeCallback} label={'Cancel'} />}
					</div>
				</div>
				{isNew &&
					<span className="auth-swap">
						Go back to <Link to="/auth/login">login</Link>?
					</span>
				}
			</form>
		)
	}
}

export default withRouter(connect(null, {
	saveUser,
	loginUser,
	logoutUser,
	changeTitle,
	clearPending,
	setTempUiColour,
	clearReferrer,
})(withValidateResponse(RegisterUser)))
